export const environment = {
  production: true,
  version: '20260318.01.c9eaa0c',
  baseApiUrl: 'https://api.uat.limgjaya.com',
  baseWebSocketUrl: 'wss://api.uat.limgjaya.com',
  baseWebSocketUrlPath: '/socket.io',
  googleMapsApiKey: 'AIzaSyAzzv0uzTJsDnsxVoBKYg1xNn8bCBrMErM',
};
